
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwitchHorizontalOff as ObiSwitchHorizontalOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-switch-horizontal-off.js';
 
 
 

 
 export const ObiSwitchHorizontalOff = createComponent({
   react: React,
   tagName: 'obi-switch-horizontal-off',
   elementClass: ObiSwitchHorizontalOffElement,
   events: {
     
   }
  });
 
 